import { combineReducers } from '@reduxjs/toolkit';
import apiReducer from './slices/apiSlice';
import accessReducer from './slices/accessSlice';
import siteReducer from './slices/siteSlice';
import uiReducer from './slices/uiSlice';
import unitsReducer from './slices/unitsSlice';

export const reducer = combineReducers({
  api: apiReducer,
  access: accessReducer,
  site: siteReducer,
  ui: uiReducer,
  units: unitsReducer,
});

export { setApiState } from './slices/apiSlice';
export { setToken, setMe } from './slices/accessSlice';
export { setLocale, setNavigateTo, setCustomState } from './slices/uiSlice';

export default reducer;
